interface SentimentMeterProps {
  sentiment: { support: number; neutral: number; doubt: number };
}

const segments = [
  { key: "support", label: "倾向当事方", bar: "bg-secondary-500", dot: "bg-secondary-500" },
  { key: "neutral", label: "中立观望", bar: "bg-background-400", dot: "bg-background-400" },
  { key: "doubt", label: "质疑追问", bar: "bg-primary-500", dot: "bg-primary-500" },
] as const;

export default function SentimentMeter({ sentiment }: SentimentMeterProps) {
  return (
    <div className="mt-6">
      <div className="flex h-3 w-full overflow-hidden rounded-full bg-background-200">
        {segments.map((segment) => (
          <span
            key={segment.key}
            className={`h-full ${segment.bar}`}
            style={{ width: `${sentiment[segment.key]}%` }}
          ></span>
        ))}
      </div>

      <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-3">
        {segments.map((segment) => (
          <div
            key={segment.key}
            className="rounded-lg border border-background-200 bg-background-50 p-4"
          >
            <div className="flex items-center gap-2">
              <span className={`h-2.5 w-2.5 rounded-full ${segment.dot}`}></span>
              <span className="text-xs text-foreground-600">{segment.label}</span>
            </div>
            <p className="mt-2 font-heading text-2xl font-bold text-foreground-950">
              {sentiment[segment.key]}%
            </p>
          </div>
        ))}
      </div>

      <p className="mt-4 text-xs leading-relaxed text-foreground-500">
        以上比例根据公开评论区的可见发言粗略统计，仅用于了解大致风向，不代表全体意见，也不作为结论依据。
      </p>
    </div>
  );
}